import { render, staticRenderFns } from "./processDesign.vue?vue&type=template&id=6e1e1220&scoped=true&"
import script from "./processDesign.vue?vue&type=script&lang=ts&"
export * from "./processDesign.vue?vue&type=script&lang=ts&"
import style0 from "./processDesign.vue?vue&type=style&index=0&id=6e1e1220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1e1220",
  null
  
)

export default component.exports